import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["src", "srcset"]
const _hoisted_2 = ["src", "srcset"]
const _hoisted_3 = {
  alt: "onboarding-modal",
  class: "onboarding-images onboarding-images--page3",
  src: "/img/illustrations/milestone-planner/onboarding-dialog-page-3.png",
  srcset: "\n        /img/illustrations/milestone-planner/onboarding-dialog-page-3@2x.png\n      "
}
const _hoisted_4 = {
  alt: "onboarding-modal",
  class: "onboarding-images onboarding-images--page4",
  src: "/img/illustrations/milestone-planner/onboarding-dialog-page-4.png",
  srcset: "\n        /img/illustrations/milestone-planner/onboarding-dialog-page-4@2x.png\n      "
}
const _hoisted_5 = {
  alt: "onboarding-modal",
  class: "onboarding-images onboarding-images--page5",
  src: "/img/illustrations/milestone-planner/onboarding-dialog-page-5.png",
  srcset: "\n        /img/illustrations/milestone-planner/onboarding-dialog-page-5@2x.png\n      "
}
const _hoisted_6 = {
  alt: "onboarding-modal",
  class: "onboarding-images onboarding-images--page6",
  src: "/img/illustrations/milestone-planner/onboarding-dialog-page-6.png",
  srcset: "\n        /img/illustrations/milestone-planner/onboarding-dialog-page-6@2x.png\n      "
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MilestoneStageStatusSelector = _resolveComponent("MilestoneStageStatusSelector")!
  const _component_PxStepByStepDialog = _resolveComponent("PxStepByStepDialog")!

  return (_openBlock(), _createBlock(_component_PxStepByStepDialog, {
    "current-page": _ctx.currentPage,
    "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
    class: _normalizeClass([`milestone-planner-onboarding-dialog--${_ctx.userType}`, "milestone-planner-onboarding-dialog"]),
    "page-count": _ctx.pageCount,
    visibility: _ctx.visibility,
    onCloseDialog: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close-dialog')))
  }, {
    title: _withCtx(() => [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("milestonePlanner.onboardingModal.title")), 1),
      _createElementVNode("p", {
        class: _normalizeClass({ 'onboarding-subtitle--compact': _ctx.currentPage > 2 })
      }, _toDisplayString(_ctx.$t(
            `milestonePlanner.onboardingModal.${_ctx.userType}.subtitle.${_ctx.dialogSubtitleIndex}`,
          )), 3)
    ]),
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", null, [
        _cache[2] || (_cache[2] = _createElementVNode("img", {
          alt: "onboarding-modal-confettis",
          class: "onboarding-image-confettis",
          src: "/img/icons/confettis.svg"
        }, null, -1)),
        _createElementVNode("img", {
          src: `/img/illustrations/milestone-planner/${_ctx.userType}/onboarding-dialog-page-1.png`,
          srcset: `
          /img/illustrations/milestone-planner/${_ctx.userType}/onboarding-dialog-page-1@2x.png
        `,
          alt: "onboarding-modal",
          class: "onboarding-images onboarding-images--page1"
        }, null, 8, _hoisted_1)
      ], 512), [
        [_vShow, _ctx.currentPage === 1]
      ]),
      _withDirectives(_createElementVNode("img", {
        src: `/img/illustrations/milestone-planner/${_ctx.userType}/onboarding-dialog-page-2.png`,
        srcset: `
          /img/illustrations/milestone-planner/${_ctx.userType}/onboarding-dialog-page-2@2x.png
        `,
        alt: "onboarding-modal",
        class: "onboarding-images onboarding-images--page2"
      }, null, 8, _hoisted_2), [
        [_vShow, _ctx.currentPage === 2]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
        [_vShow, _ctx.currentPage === 3]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
        [_vShow, _ctx.currentPage === 4]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
        [_vShow, _ctx.currentPage === 5]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
        [_vShow, _ctx.currentPage === 6]
      ]),
      (_ctx.currentPage > 2)
        ? (_openBlock(), _createBlock(_component_MilestoneStageStatusSelector, {
            key: 0,
            "selected-status": _ctx.currentPage - _ctx.pagesWithoutSelector,
            onSelectedStatus: _ctx.changePage
          }, null, 8, ["selected-status", "onSelectedStatus"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["current-page", "class", "page-count", "visibility"]))
}